var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("fal fa-chevronleft")]),_vm._v("\n  Back\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }